module.exports = __webpack_public_path__ + "202408221624/img/img_card_default.09ffef97.png";